<template>
	<span :aria-hidden="!title"
		:aria-label="title"
		class="material-design-icon phonetrack-icon"
		role="img"
		v-bind="$attrs"
		@click="$emit('click', $event)">
		<svg
			:fill="fillColor"
			:width="size"
			:height="size"
			enable-background="new 0 0 512 512"
			version="1.1"
			viewBox="0 0 512 512"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg">
			<path d="m259.78 0.63281c-22.471-0.0036-38.727 2.4744-58.799 8.959-29.117 9.4067-54.594 25.063-76.607 47.076-30.622 30.622-49.604 69.627-54.885 112.78-1.9489 15.926-1.178 36.707 1.9082 51.393 10.072 47.926 41.535 113.02 87.23 180.46 36.079 53.253 75.774 98.778 94.123 107.95 2.5241 1.2613 5.7546 2.293 7.1777 2.293 15.42 0 60.84-50.154 104.45-115.34 41.154-61.515 70.636-121.5 81.744-166.3 3.9051-15.752 5.0957-25.084 5.0762-39.805-0.0567-42.93-14.425-83.339-42.115-118.45-5.5275-7.0087-21.984-23.441-29.146-29.102-24.308-19.21-52.287-32.35-81.566-38.311-13.385-2.725-22.767-3.6029-38.588-3.6055zm-52.375 53.906h105.27c18.252 0 33.076 14.804 33.076 33.037v244.45c0 18.251-14.831 33.014-33.109 33.014h-105.27c-18.27-0.018-33.076-14.783-33.076-33.016v-244.45c0-18.233 14.834-33.037 33.109-33.037zm30.092 20.119c-1.8262 0-3.3167 1.3214-3.3164 2.9395 0 1.625 1.5099 2.9473 3.3164 2.9473h45.088c1.8328 0 3.3184-1.3223 3.3184-2.9473 0-1.6181-1.4921-2.9395-3.3184-2.9395zm-45.264 32.293c-2.7361 0-4.9531 2.2216-4.9531 4.9609v194.89c0 2.729 2.2171 4.9434 4.9531 4.9434h135.62c2.7426 0 4.9512-2.2144 4.9512-4.9434v-194.89c0-2.7497-2.2086-4.9609-4.9512-4.9609zm67.822 215.8c-8.1983 0-14.799 6.946-14.799 15.533-1e-5 8.5492 6.6104 15.518 14.799 15.518 8.1589 0 14.762-6.958 14.762-15.518 0-8.5975-6.593-15.533-14.762-15.533z" />
		</svg>
	</span>
</template>

<script>
export default {
	name: 'PhonetrackIcon',
	props: {
		title: {
			type: String,
			default: '',
		},
		fillColor: {
			type: String,
			default: 'currentColor',
		},
		size: {
			type: Number,
			default: 24,
		},
	},
}
</script>
